(function ($) {
  'use strict';

  /*--
    Menu Stick
    -----------------------------------*/
  var header = $('.sticky-bar');
  var win = $(window);
  win.on('scroll', function () {
    var scroll = win.scrollTop();
    if (scroll < 30) {
      header.removeClass('stick');
    } else {
      header.addClass('stick');
    }
  });

  /*--------------------------------
        Slider active 1
    -----------------------------------*/

  /*--------------------------------
        Slider active 2
    -----------------------------------*/

  /*---------------------
        Countdown 1
      --------------------- */
  $('.timer-1 [data-countdown]').each(function () {
    var $this = $(this),
      finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function (event) {
      $this.html(
        event.strftime(
          '<span class="cdown day"> <span>%-D </span><p>Days</p></span> <span class="cdown hour"> <span> %-H</span> <p>Hours</p></span> <span class="cdown minutes"><span>%M</span> <p>Minutes</p> </span>',
        ),
      );
    });
  });

  $('.timer-2 [data-countdown]').each(function () {
    var $this = $(this),
      finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function (event) {
      $this.html(
        event.strftime(
          '<span class="cdown day"> <span>%-D </span><p>Day</p></span> <span class="cdown hour"> <span> %-H</span> <p>Hour</p></span> <span class="cdown minutes"><span>%M</span> <p>Minute</p> </span> <span class="cdown second"><span>%S</span> <p>Second</p> </span>',
        ),
      );
    });
  });

  $('.timer-3 [data-countdown]').each(function () {
    var $this = $(this),
      finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function (event) {
      $this.html(
        event.strftime(
          '<span class="cdown hour"> <span> %-H</span> <p>Hour</p></span> <span class="cdown minutes"><span>%M</span> <p>Minute</p> </span> <span class="cdown second"><span>%S</span> <p>Second</p> </span>',
        ),
      );
    });
  });

  /*---------------------
        svg img color
    --------------------- */
  // Elements to inject
  var mySVGsToInject = document.querySelectorAll('img.inject-me');
  // Do the injection

  /*----------------------------
    	Cart Plus Minus Button
    ------------------------------ */
  var CartPlusMinus = $('.cart-plus-minus');
  CartPlusMinus.prepend('<div class="dec qtybutton">-</div>');
  CartPlusMinus.append('<div class="inc qtybutton">+</div>');
  $('.qtybutton').on('click', function () {
    var $button = $(this);
    var oldValue = $button.parent().find('input').val();
    if ($button.text() === '+') {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.parent().find('input').val(newVal);
  });

  /*------- Color active -----*/
  $('.pro-details-color-content').on('click', 'a', function (e) {
    e.preventDefault();
    $(this).addClass('active').parent().siblings().children('a').removeClass('active');
  });

  /*--------------------------------
        Cart active
    -----------------------------------*/
  if ($('.pro-details-action').length) {
    var $body = $('body'),
      $cartWrap = $('.pro-details-action'),
      $cartContent = $cartWrap.find('.product-dec-social');
    $cartWrap.on('click', '.social', function (e) {
      e.preventDefault();
      var $this = $(this);
      if (!$this.parent().hasClass('show')) {
        $this.siblings('.product-dec-social').addClass('show').parent().addClass('show');
      } else {
        $this.siblings('.product-dec-social').removeClass('show').parent().removeClass('show');
      }
    });
    /*Close When Click Outside*/
    $body.on('click', function (e) {
      var $target = e.target;
      if (
        !$($target).is('.pro-details-action') &&
        !$($target).parents().is('.pro-details-action') &&
        $cartWrap.hasClass('show')
      ) {
        $cartWrap.removeClass('show');
        $cartContent.removeClass('show');
      }
    });
  }

  /* Language-dropdown */
  $('.language-dropdown-active').on('click', function (e) {
    e.preventDefault();
    $(this).parent().find('.language-dropdown').slideToggle('medium');
  });

  /*--------------------------------
        Testimonial active
    -----------------------------------*/

  /*====== SidebarCart ======*/
  function miniCart() {
    var navbarTrigger = $('.cart-active'),
      endTrigger = $('.cart-close'),
      container = $('.sidebar-cart-active'),
      wrapper2 = $('.main-wrapper');

    wrapper2.prepend('<div class="body-overlay"></div>');

    navbarTrigger.on('click', function (e) {
      e.preventDefault();
      container.addClass('inside');
      wrapper2.addClass('overlay-active');
    });

    endTrigger.on('click', function () {
      container.removeClass('inside');
      wrapper2.removeClass('overlay-active');
    });

    $('.body-overlay').on('click', function () {
      container.removeClass('inside');
      wrapper2.removeClass('overlay-active');
    });
  }
  miniCart();

  /*-------------------------------
	   Header Search Toggle
    -----------------------------------*/
  var searchToggle = $('.search-toggle');
  searchToggle.on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).siblings('.search-wrap-3').removeClass('open');
    } else {
      $(this).addClass('open');
      $(this).siblings('.search-wrap-3').addClass('open');
    }
  });

  /*====== Sidebar Active ======*/
  function sidebarActive() {
    var navbarTrigger = $('.sidebar-active'),
      endTrigger = $('.sidebar-close'),
      container = $('.clickalbe-sidebar-wrapper-active'),
      wrapper3 = $('.main-wrapper-2');

    wrapper3.prepend('<div class="body-overlay-2"></div>');

    navbarTrigger.on('click', function (e) {
      e.preventDefault();
      container.addClass('sidebar-visible');
      wrapper3.addClass('overlay-active-2');
    });

    endTrigger.on('click', function () {
      container.removeClass('sidebar-visible');
      wrapper3.removeClass('overlay-active-2');
    });

    $('.body-overlay-2').on('click', function () {
      container.removeClass('sidebar-visible');
      wrapper3.removeClass('overlay-active-2');
    });
  }
  sidebarActive();

  /*====== clickable Main Menu active ======*/
  var $clickableMainMenu = $('.clickable-mainmenu-wrap'),
    $clickableSubMenu = $clickableMainMenu.find('.sub-menu-2');
  /*Add Toggle Button in Off Canvas Sub Menu*/
  $clickableSubMenu
    .siblings('a')
    .append('<span class="menu-expand"><i class="icofont-plus"></i></span>');
  /*Close Off Canvas Sub Menu*/
  $clickableSubMenu.slideUp();
  /*Category Sub Menu Toggle*/
  $clickableMainMenu.on('click', 'li a, li .menu-expand', function (e) {
    var $this = $(this);
    if (
      $this.parent('li').hasClass('has-sub-menu') ||
      $this.attr('href') === '#' ||
      $this.hasClass('menu-expand')
    ) {
      e.preventDefault();
      if ($this.siblings('ul:visible').length) {
        $this
          .parent('li')
          .removeClass('active')
          .children('ul')
          .slideUp()
          .siblings('a')
          .find('.menu-expand i')
          .removeClass('icofont-minus')
          .addClass('icofont-plus');
        $this
          .parent('li')
          .siblings('li')
          .removeClass('active')
          .find('ul:visible')
          .slideUp()
          .siblings('a')
          .find('.menu-expand i')
          .removeClass('icofont-minus')
          .addClass(' icofont-plus ');
      } else {
        $this
          .parent('li')
          .addClass('active')
          .children('ul')
          .slideDown()
          .siblings('a')
          .find('.menu-expand i')
          .removeClass(' icofont-plus ')
          .addClass('icofont-minus');
        $this
          .parent('li')
          .siblings('li')
          .removeClass('active')
          .find('ul:visible')
          .slideUp()
          .siblings('a')
          .find('.menu-expand i')
          .removeClass('icofont-minus')
          .addClass(' icofont-plus ');
      }
    }
  });

  /*====== Sidebar menu Active ======*/
  function mobileMenuActive() {
    var navbarTrigger = $('.mobile-menu-button-active'),
      endTrigger = $('.sidebar-close'),
      container = $('.mobile-menu-active'),
      wrapper4 = $('.main-wrapper-3');

    wrapper4.prepend('<div class="body-overlay-3"></div>');

    navbarTrigger.on('click', function (e) {
      e.preventDefault();
      container.addClass('sidebar-visible');
      wrapper4.addClass('overlay-active-3');
    });

    endTrigger.on('click', function () {
      container.removeClass('sidebar-visible');
      wrapper4.removeClass('overlay-active-3');
    });

    $('.body-overlay-3').on('click', function () {
      container.removeClass('sidebar-visible');
      wrapper4.removeClass('overlay-active-3');
    });
  }
  mobileMenuActive();

  /*--- Language currency active ----*/
  $('.mobile-language-active').on('click', function (e) {
    e.preventDefault();
    $('.lang-dropdown-active').slideToggle(900);
  });

  /*------------------------------------
        Testimonial img slider active
    -----------------------------------*/

  /*--------------------------
        Isotope active
    ---------------------------- */

  /*====== SidebarSearch ======*/
  function sidebarSearch() {
    var searchTrigger = $('.search-active'),
      endTriggersearch = $('.megashop-search-close'),
      container = $('.main-search-active');

    searchTrigger.on('click', function (e) {
      e.preventDefault();
      container.addClass('search-visible');
    });

    endTriggersearch.on('click', function () {
      container.removeClass('search-visible');
    });
  }
  sidebarSearch();

  /*---------------------
        Price range
    --------------------- */
  /*-------------------------------------
        checkout one click toggle function
    ---------------------------------------*/
  var checked = $('.sin-payment input:checked');
  if (checked) {
    $(checked).siblings('.payment-box').slideDown(900);
  }
  $('.sin-payment input').on('change', function () {
    $('.payment-box').slideUp(900);
    $(this).siblings('.payment-box').slideToggle(900);
  });

  /*-----------------------
        Shop filter active 
    ------------------------- */
  $('.shop-filter-active').on('click', function (e) {
    e.preventDefault();
    $('.product-filter-wrapper').slideToggle();
  });
  var shopFiltericon = $('.shop-filter-active');
  shopFiltericon.on('click', function () {
    $('.shop-filter-active').toggleClass('active');
  });
  /*--------------------------
        Tab active
    ---------------------------- */
  var ProductDetailsSmall = $('.product-details-tab-small a');
  ProductDetailsSmall.on('click', function (e) {
    e.preventDefault();
    var $href = $(this).attr('href');
    ProductDetailsSmall.removeClass('active');
    $(this).addClass('active');
    $('.product-details-tab-large .tab-pane').removeClass('active');
    $('.product-details-tab-large ' + $href).addClass('active');
  });
})(jQuery);
